import { useTablet } from "hooks/useMediaQuery";

export const useMain = () => {
  const isTable = useTablet();

  return {
    isTable,
  };
};
